import InstitutionTable from '../components/institutionsTable/institutionTable.vue'

export default {
  components: {
    InstitutionTable,
  },

  data: () => ({}),

  methods: {},

  created() {},
}
